




































import { defineComponent, computed } from "@vue/composition-api";

import CvEducationSection from "@/components/cv/cv-education-section.vue";
import CvExperienceSection from "@/components/cv/cv-experience-section.vue";
import CvHobbySection from "@/components/cv/cv-hobby-section.vue";
import CvLanguageSection from "@/components/cv/cv-language-section.vue";
import CvSection from "@/components/cv/cv-section.vue";
import CvSkillSection from "@/components/cv/cv-skill-section.vue";
import CvSocialSection from "@/components/cv/cv-social-section.vue";
import { MyCV } from "@/data/cv";

export default defineComponent({
  name: "Cv",
  components: {
    CvEducationSection,
    CvExperienceSection,
    CvHobbySection,
    CvLanguageSection,
    CvSection,
    CvSkillSection,
    CvSocialSection
  },

  setup() {
    const profile = computed(() => MyCV);
    return { profile };
  }
});
